<template>
  <page-view :title="false">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="小区名称"
                ><a-input
                  v-model="queryParam.communityName"
                  placeholder="小区名称"
              /></a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="小区代码"
                ><a-input
                  v-model="queryParam.communityCode"
                  placeholder="小区代码"
              /></a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="状态">
                  <a-select
                    v-model="queryParam.sta"
                    placeholder="请选择"
                    allowClear
                  >
                    <a-select-option value="I">正常</a-select-option>
                    <a-select-option value="X">停用</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="省份">
                  <a-select
                    v-model="queryParam.provinces"
                    placeholder="请选择省份"
                    allow-clear
                    @change="handleProvinceChange"
                  >
                    <a-select-option
                      v-for="item in provinceList"
                      :value="item.code"
                      :key="item.code"
                    >
                      {{ item.descript }}({{ item.code }})
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="城市">
                  <a-select
                    v-model="queryParam.city"
                    placeholder="请选择城市"
                    allowClear
                    @change="handleCityChange"
                  >
                    <a-select-option
                      v-for="item in tmpCityList"
                      :value="item.code"
                      :key="item.code"
                    >
                      {{ item.descript }}({{ item.code }})
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="区域">
                  <a-select
                    v-model="queryParam.region"
                    placeholder="请选择区域"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in tmpDistrictList"
                      :value="item.code"
                      :key="item.code"
                    >
                      {{ item.descript }}({{ item.code }})
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)"
                  >查询</a-button
                >
                <a-button
                  class="button-margin-left"
                  @click="() => (queryParam = {})"
                  >重置</a-button
                >
                <a-button
                  class="button-margin-left"
                  type="primary"
                  icon="plus"
                  @click="add"
                  v-hasAnyPermission="`community:add`"
                  >新建</a-button
                >

                <a @click="toggleAdvanced" class="button-margin-left">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 数据表格 -->
      <s-table
        ref="table"
        rowKey="id"
        :scroll="{ x: 2500 }"
        :columns="columns"
        :data="loadData"
        showPagination="auto"
      >
        <span slot="tagItem" slot-scope="text, record">
          <template>
            {{ text }}
            <a-tag class="render-tag" color="grey" v-if="record.sta == 'X'"
              >已停用</a-tag
            >
          </template>
        </span>
        <span slot="action" slot-scope="text, record">
          <template>
            <a
              class="a-action"
              @click="action(record, 'edit')"
              v-hasAnyPermission="`community:edit`"
              >编辑</a
            >

            <a-popconfirm
              title="确认删除?"
              @confirm="action(record, 'del')"
              okText="确认"
              cancelText="取消"
              v-hasAnyPermission="`community:delete`"
              ><a class="a-action">删除</a></a-popconfirm
            >
          </template>
        </span>
      </s-table>
    </a-card>
    <community-info
      ref="communityInfo"
      :provinceList="provinceList"
      :cityList="cityList"
      :districtList="districtList"
      @success="$refs.table.refresh(true)"
    ></community-info>
  </page-view>
</template>

<script>
import moment from "moment";
import { STable } from "@/components";
import { PageView } from "@/layouts";
import CommunityInfo from "./CommunityInfo.vue";

export default {
  name: "CircleList",
  components: {
    STable,
    PageView,
    CommunityInfo
  },
  data() {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      provinceList: [],
      cityList: [],
      tmpCityList: [],
      districtList: [],
      tmpDistrictList: [],
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: "小区代码",
          dataIndex: "communityCode",
          fixed: "left"
        },
        {
          title: "小区名称",
          dataIndex: "communityName",
          scopedSlots: { customRender: "tagItem" },
          fixed: "left"
        },
        {
          title: "位置",
          dataIndex: "position",
          fixed: "left",
          ellipsis: true
        },
        {
          title: "经度",
          dataIndex: "longitude"
        },
        {
          title: "纬度",
          dataIndex: "latitude"
        },
        {
          title: "省",
          dataIndex: "provinces"
        },
        {
          title: "市",
          dataIndex: "city"
        },
        {
          title: "区",
          dataIndex: "region"
        },
        {
          title: "商圈",
          dataIndex: "busiCircle"
        },
        {
          title: "操作人",
          dataIndex: "modifyUser"
        },
        {
          title: "更新时间",
          dataIndex: "modifyDatetime"
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "left",
          fixed: "right",
          scopedSlots: { customRender: "action" }
        }
      ],
      //加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return this.$http.roomBksApi
          .pageHouseCommunity(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.resultObject;
          });
      }
    };
  },
  created() {
    this.getBaseHelpCode();
  },
  methods: {
    /**
     * 操作
     * @param {Object} record
     * @param {Object} type
     */
    action(record, type) {
      if (type == "edit") {
        this.$refs.communityInfo.showModal(type, Object.assign({}, record));
      } else if (type == "del") {
        this.$http.roomBksApi
          .removeHouseCommunity({ communityCode: record.communityCode })
          .then(res => {
            if (res.result == 0) {
              this.$refs.table.refresh(true);
              this.$message.success(res.msg);
            }
          });
      }
    },
    add() {
      this.$refs.communityInfo.showModal("add", null);
    },
    /**
     * 展开/收起查询条件
     */
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    getBaseHelpCode() {
      this.$http.systemBksApi
        .findProvinceCityDistrictCircleHelpCode({
          isProvince: "T",
          isCity: "T",
          isDistrict: "T"
        })
        .then(res => {
          this.provinceList = res.resultObject.provinceList;
          this.cityList = res.resultObject.cityList;
          this.districtList = res.resultObject.districtList;
        });
    },
    handleProvinceChange(value) {
      let arr = [];
      for (let city of this.cityList) {
        if (city.provinceCode == value) {
          arr.push(city);
        }
      }
      this.tmpCityList = arr;
    },
    handleCityChange(value) {
      let arr = [];
      for (let district of this.districtList) {
        if (district.cityCode == value) {
          arr.push(district);
        }
      }
      this.tmpDistrictList = arr;
    }
  }
};
</script>
